module.exports = __webpack_public_path__ + "static/about-team3-eefbb4522efea8a36f987f9d4cf1efae.jpg";